import * as React from 'react';
import * as moment from 'moment-timezone';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import { CustomPage } from '@crochik/pi-react/application/Page';

import './Confirmation.css';
import App from '@crochik/pi-react/application/App';
import { Appointment } from '@crochik/schedulerapi.ts';

interface Props {

}
interface State {
    message?: string;
    appointment?: Appointment;
}

class ConfirmationPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    async componentDidMount() {
        let args = App().args;
        var appt: Appointment|undefined = args[1];

        var path = appt && appt.start ? 'confirmation' : 'contact';
        var resp = await fetch(`frag/${path}.html`);
        var html = await resp.text();
        this.setState({
            ...this.state,
            message: html,
            appointment: appt
        });
    }

    renderMessage() {
        if (!this.state.appointment || !this.state.appointment.start) return undefined;

        var date: string | undefined;
        var time: string | undefined;

        var mStart = moment(this.state.appointment.start);
        date = mStart.format('dddd, MM/DD/YYYY');
        time = mStart.format('hh:mm A');

        return (
            <div className="Confirmation_body">
                <Typography paragraph={true}>
                    <b>{this.state.appointment.subject}</b><br />
                    {date} at {time}
                </Typography>
            </div>
        );
    }

    render() {
        var html;
        if (this.state.message) {
            html = {
                __html: this.state.message
            };
        }

        return (
            <div className="pi-content">
                <Card className="Confirmation">
                    <CardContent key="body">
                        {html && <div dangerouslySetInnerHTML={html} />}
                        {this.renderMessage()}
                    </CardContent>
                </Card>
            </div>
        );
    }
}

export default (name: string, title: string) => new CustomPage({ name, label: title }, <ConfirmationPage />);


// WEBPACK FOOTER //
// ./src/app/pages/Confirmation/index.tsx